import apiClient from '@/services/axios'

export const exportFulfillmentList = (params) => {
  return apiClient({
    method: 'get',
    url: '/fulfillment/export-do',
    headers: {
      'Business-Id': params.business_id,
    },
    params,
  })
}

export const checkRequestExportFulfillmentList = ({ request_id, params }) => {
  return apiClient({
    method: 'get',
    url: `fulfillment/request-status/${request_id}`,
    params,
  })
}

export const getFulfillmentList = ({ url, params }) => {
  const newUrl = params?.check_trouble_do 
    ? `/${url}/internal/list-trouble` 
    : `/${url}/list`
  return apiClient({
    method: 'get',
    url: newUrl,
    params,
  })
}

export const getTotalFulfillmentList = (params) => {
  return apiClient({
    method: 'get',
    url: '/fulfillment/total-list',
    params,
  })
}

export const getFulfillmentViewList = (params) => {
  return apiClient({
    method: 'get',
    url: '/fulfillment/list-view',
    params,
  })
}

export const getFulfillmentViewCount = (params) => {
  return apiClient({
    method: 'get',
    url: '/fulfillment/list-count',
    params,
  })
}

export const getFulfillmentDetail = ({ url, internal = false, fulfillment_id, params = undefined }) => {
  const path = internal ? '/internal' : ''
  return apiClient({
    method: 'get',
    url: `/${url + path}/detail/${fulfillment_id}`,
    params,
  })
}

export const getFulfillmentDetailByOrder = ({ signal, business_id, order_id }) => {
  return apiClient({
    signal,
    method: 'get',
    url: `/fulfillment/order/${order_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const getCatalogFulfillment = (params) => {
  return apiClient({
    method: 'get',
    url: '/fulfillment-cmd/internal/catalog',
    params,
  })
}

export const splitShipment = ({ business_id, url, data }) => {
  return apiClient({
    method: 'post',
    url: `/${url}-cmd/split`,
    headers: {
      'Business-id': business_id,
    },
    data,
    params: { business_id },
  })
}

export const submitToWMS = ({ business_id, data }) => {
  return apiClient({
    method: 'post',
    url: '/fulfillment-cmd/wms',
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const submitFulfillmentRevision = ({ fulfillment_id, business_id, data }) => {
  return apiClient({
    method: 'post',
    url: `/fulfillment-cmd/replacement/${fulfillment_id}`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const bulkOrderProcess = ({ business_id, state, data }) => {
  return apiClient({
    method: 'put',
    url: `/fulfillment-cmd/state/${state}`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const changeQty = ({ url, fulfillment_id, data }) => {
  return apiClient({
    method: 'put',
    url: `/${url}-cmd/${fulfillment_id}/items`,
    data,
  })
}

export const updateFulfillmentStatus = ({ url, type, data }) => {
  return apiClient({
    method: 'put',
    url: `/${url}-cmd/state/${type}`,
    data,
  })
}

export const fulfillmentCancelItem = ({ url, fulfillment_id, data }) => {
  return apiClient({
    method: 'delete',
    url: `/${url}-cmd/${fulfillment_id}/remove-item`,
    data,
  })
}

export const getPublicFulfillmentDetail = ({ fulfillment_id, workspace_id }) => {
  return apiClient({
    method: 'get',
    url: `/fulfillment/internal/shipping-label/${fulfillment_id}`,
    headers: {
      'Workspace-Id': workspace_id,
    },
  })
}

export const getInternalFulfillmentByOrder = ({ order_id, workspace_id }) => {
  const headers = {}
  if (workspace_id) {
    headers['Workspace-Id'] = workspace_id
  }
  return apiClient({
    method: 'get',
    url: `/fulfillment/internal/order/${order_id}`,
    headers,
  })
}